import AuthController from "../../app/Merchant/Controller/AuthController";

export default class AccessLevel {

    // Default use access_level from window, then later update to use accessLevel from AuthController
    accessLevel = window.access_level

    // https://codeburst.io/using-javascript-bitwise-operators-in-real-life-f551a731ff5
    static ACCESS_SUPER_ADMIN           = 1;        // 0001
    static ACCESS_TABLE_LISTING         = 1 << 1;   // 0010
    static ACCESS_ADMIN_PLACE_ORDER     = 1 << 2;   // 0100
    static ACCESS_ADMIN_PAY_BILL        = 1 << 3;   // 1000
    static ACCESS_ADMIN_VOID            = 1 << 4;   // You get the idea...
    static ACCESS_SALES_BREAKDOWN       = 1 << 5;
    static ACCESS_REPORT                = 1 << 6;
    static ACCESS_KITCHEN_VIEW          = 1 << 7;
    static ACCESS_RECORD                = 1 << 8;
    static ACCESS_CATALOG               = 1 << 9;
    static ACCESS_DASHBOARD             = 1 << 10;
    static ACCESS_EDIT_TABLE_CANVAS     = 1 << 11;
    static ACCESS_DO_NOT_ALLOW_EDIT_CATALOG_NAME    = 1 << 12;
    static ACCESS_DO_NOT_ALLOW_EDIT_CATALOG_PRICE   = 1 << 13;
    static ACCESS_DO_NOT_ALLOW_DELETE_CATALOG_ITEM  = 1 << 14;
    static ACCESS_INVENTORY_MODULE      = 1 << 15;
    static ACCESS_SEPARATE_BILL_REPORT  = 1 << 17;
    static ACCESS_WORK_SESSION_REPORT   = 1 << 18;
    static ACCESS_WORK_SESSION_BASIC    = 1 << 19;
    static ACCESS_COUNTER_FULL_ACCESS   = 1 << 20;
    static ACCESS_BILL_VOID_COMPLETED   = 1 << 21;
    static ACCESS_BILL_DELETE_COMPLETED   = 1 << 22;
    static ACCESS_BILL_CHANGE_DINE_IN_PAYMENT_METHOD   = 1 << 23;
    static ACCESS_BILL_FULL_ACCESS   = 1 << 24;

    static descriptionMap = {
        [AccessLevel.ACCESS_SUPER_ADMIN]: "Super Admin",
        [AccessLevel.ACCESS_TABLE_LISTING]: "Table Listing",
        [AccessLevel.ACCESS_ADMIN_PLACE_ORDER]: "Admin place order",
        [AccessLevel.ACCESS_ADMIN_PAY_BILL]: "Admin pay bill",
        [AccessLevel.ACCESS_ADMIN_VOID]: "Void",
        [AccessLevel.ACCESS_SALES_BREAKDOWN]: "Sales Breakdown",
        [AccessLevel.ACCESS_REPORT]: "Report",
        [AccessLevel.ACCESS_KITCHEN_VIEW]: "Kitchen View",
        [AccessLevel.ACCESS_RECORD]: "Record",
        [AccessLevel.ACCESS_CATALOG]: "Catalog",
        [AccessLevel.ACCESS_DASHBOARD]: "Dashboard",
        [AccessLevel.ACCESS_DO_NOT_ALLOW_EDIT_CATALOG_NAME]: "Do Not Allow Edit Catalog Name",
        [AccessLevel.ACCESS_DO_NOT_ALLOW_EDIT_CATALOG_PRICE]: "Do Not Allow Edit Catalog Price",
        [AccessLevel.ACCESS_DO_NOT_ALLOW_DELETE_CATALOG_ITEM]: "Do Not Allow Delete Catalog Item",
        [AccessLevel.ACCESS_INVENTORY_MODULE]: "Access Inventory Module",
        [AccessLevel.ACCESS_SEPARATE_BILL_REPORT]: "Super admin able to view bill report separately for this user",
        [AccessLevel.ACCESS_WORK_SESSION_REPORT]: "View Work Session Report",
        [AccessLevel.ACCESS_COUNTER_FULL_ACCESS]: "Counter full access (Create/Edit)",
        [AccessLevel.ACCESS_BILL_FULL_ACCESS]: "Bill - Full Access",
        [AccessLevel.ACCESS_BILL_VOID_COMPLETED]: "Bill - Void Completed Bill",
        [AccessLevel.ACCESS_BILL_DELETE_COMPLETED]: "Bill - Delete Completed Bill",
        [AccessLevel.ACCESS_BILL_CHANGE_DINE_IN_PAYMENT_METHOD]: "Bill (Dine In) - Change Payment Method",
    }

    listenerMap = new Map()
    constructor() {
        AuthController.addCurrentUserChangeListener(this, (currentUser) => {
            this.accessLevel = currentUser.access_level
            this.notifyAllListener()
        })
    }

    /**
     * @returns {AccessLevel}
     */
    static getInstance = () => {
        return _instance
    }
    notifyListener = (callback, context) => {
        if (!context) {
            // No specific context, just fire the callback
            callback(this.accessLevel)
        }
        else {
            // The callback is attached to a specific context, check if context still valid
            if (this.listenerMap.has(context)) {
                callback(this.accessLevel)
            }
        }
    }
    notifyAllListener = () => {
        for (let [context, callback] of this.listenerMap) {
            this.notifyListener(callback, context)
        }
    }
    addOnChangeListener = (context, callback) => {
        this.listenerMap.set(context, callback)
        setTimeout(() => {
            this.notifyListener(callback, context)
        }, 100)
        return this
    }
    removeAllListeners = (context) => {
        this.listenerMap.delete(context)
    }

    static isSuperAdmin = () => {
        return !!(parseInt(_instance.accessLevel) & AccessLevel.ACCESS_SUPER_ADMIN)
    }
    static allowDashboardModule = () => {
        return !!(AccessLevel.isSuperAdmin() || parseInt(_instance.accessLevel) & AccessLevel.ACCESS_DASHBOARD)
    }
    static allowTableModule = () => {
        return !!(AccessLevel.isSuperAdmin() || parseInt(_instance.accessLevel) & AccessLevel.ACCESS_TABLE_LISTING)
    }
    static allowAdminPlaceOrderModule = () => {
        return !!(AccessLevel.isSuperAdmin() || parseInt(_instance.accessLevel) & AccessLevel.ACCESS_ADMIN_PLACE_ORDER)
    }
    static allowSalesBreakdownModule = () => {
        return !!(AccessLevel.isSuperAdmin() || parseInt(_instance.accessLevel) & AccessLevel.ACCESS_SALES_BREAKDOWN)
    }
    static allowReportModule = () => {
        return !!(AccessLevel.isSuperAdmin() || parseInt(_instance.accessLevel) & AccessLevel.ACCESS_REPORT)
    }
    static allowKitchenViewModule = () => {
        return !!(AccessLevel.isSuperAdmin() || parseInt(_instance.accessLevel) & AccessLevel.ACCESS_KITCHEN_VIEW)
    }
    static allowRecordModule = () => {
        return !!(AccessLevel.isSuperAdmin() || parseInt(_instance.accessLevel) & AccessLevel.ACCESS_RECORD)
    }
    static allowCatalogModule = () => {
        return !!(AccessLevel.isSuperAdmin() || parseInt(_instance.accessLevel) & AccessLevel.ACCESS_CATALOG)
    }
    static allowInventoryModule = () => {
        return !!(AccessLevel.isSuperAdmin() || parseInt(_instance.accessLevel) & AccessLevel.ACCESS_INVENTORY_MODULE)
    }
    static allowPayBillModule = () => {
        return !!(AccessLevel.isSuperAdmin() || parseInt(_instance.accessLevel) & AccessLevel.ACCESS_ADMIN_PAY_BILL)
    }
    static allowEditTableCanvas = () => {
        return !!(AccessLevel.isSuperAdmin() || parseInt(_instance.accessLevel) & AccessLevel.ACCESS_EDIT_TABLE_CANVAS)
    }
    static allowVoidModule = () => {
        return !!(AccessLevel.isSuperAdmin() || parseInt(_instance.accessLevel) & AccessLevel.ACCESS_ADMIN_VOID)
    }
    static doNotAllowEditCatalogName = () => {
        return !!(parseInt(_instance.accessLevel) & AccessLevel.ACCESS_DO_NOT_ALLOW_EDIT_CATALOG_NAME)
    }
    static doNotAllowEditCatalogPrice = () => {
        return !!(parseInt(_instance.accessLevel) & AccessLevel.ACCESS_DO_NOT_ALLOW_EDIT_CATALOG_PRICE)
    }
    static doNotAllowDeleteCatalogItem = () => {
        return !!(parseInt(_instance.accessLevel) & AccessLevel.ACCESS_DO_NOT_ALLOW_DELETE_CATALOG_ITEM)
    }
    static allowWorkSessionModule = () => {
        return !!(AccessLevel.isSuperAdmin() || parseInt(_instance.accessLevel) & AccessLevel.ACCESS_WORK_SESSION_REPORT)
    }
    static allowWorkSessionReportModule = () => {
        return !!(AccessLevel.isSuperAdmin() || parseInt(_instance.accessLevel) & AccessLevel.ACCESS_WORK_SESSION_REPORT)
    }
    static counterFullAccess = () => {
        return !!(AccessLevel.isSuperAdmin() || parseInt(_instance.accessLevel) & AccessLevel.ACCESS_COUNTER_FULL_ACCESS)
    }

    static bill = {
        allowDeleteCompleted: () => {
            return !!(AccessLevel.isSuperAdmin() || parseInt(_instance.accessLevel) & AccessLevel.ACCESS_BILL_DELETE_COMPLETED)
        },
        allowVoidCompleted: () => {
            return !!(AccessLevel.isSuperAdmin() || parseInt(_instance.accessLevel) & AccessLevel.ACCESS_BILL_VOID_COMPLETED)
        },
        allowChangeDineInPaymentMethod: () => {
            return !!(AccessLevel.isSuperAdmin() || parseInt(_instance.accessLevel) & (AccessLevel.ACCESS_BILL_FULL_ACCESS | AccessLevel.ACCESS_BILL_CHANGE_DINE_IN_PAYMENT_METHOD))
        }
    }
}

// Singleton instance
const _instance = new AccessLevel()

